import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "73",
  height: "68",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M36.019 1.676c2.192-.144 4.239.64 5.686 2.311 10.19 17.642 19.739 35.693 29.718 53.472 1.888 4.15-.202 8.335-4.72 8.884H6.4c-4.763-.378-6.934-5.357-4.532-9.38C11.531 40.32 20.058 22.962 29.788 6.364c1.554-2.651 2.893-4.469 6.231-4.688Zm-.12 3.763c-.304.061-.967.505-1.203.729-10.07 17.58-19.702 35.48-29.504 53.234-.602 1.708.009 3.12 1.887 3.283h58.719c2.262-.17 2.687-1.902 1.813-3.781L38.481 6.326a2.613 2.613 0 0 0-2.582-.887Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M35.56 18.817c2.143-.311 4.61.63 5.276 2.85.425 1.413-.018 4.278-.147 5.864-.55 6.701-1.294 13.39-1.838 20.093-.493 2.176-4.291 2.13-4.709-.114l-2.185-24.203c-.15-2.142 1.516-4.186 3.606-4.488l-.002-.002ZM35.788 51.394c4.81-.709 5.2 5.313 1.529 5.887-4.808.752-5.453-5.309-1.53-5.887Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }